import gql from "graphql-tag.macro";
import { getClient } from "Globals/api";

const actionQuery = gql`
query getMyProjectActions {
  pending: myactions(status: [PENDING], filter: { project: "CURRENT" }) {
    edges {
      node {
        ...DashboardListofActionWidget
      }
    }
  }
  fulfilled: myactions(
    status: [FULFILLED]
    filter: { project: "CURRENT" }
    meta: { createdBefore: "Date.now()-2WE" }
  ) {
    edges {
      node {
        ...DashboardListofActionWidget
      }
    }
  }
}
fragment DashboardListofActionWidget on Action {
  _id
  status
  _meta {
    lastModifiedAt
  }
  _parent {
    parent {
      ... on Workflowinstance {
        _parent {
          _id
          model
        }
        currentStage {
          name
        }
        log {
          data {
            data {
              comment
              who {
                id
                email
                firstname
                lastname
              }
              why {
                robot {
                  t
                  comment
                  related
                  relatedKind
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

export const loadActions = async () => {
    const client = await getClient("actionlist");
    const { data } = await client.query({
        query: actionQuery,
        // variables: { payload: { type: "project", id: mdContext.project } },
    });
    return data;
};
